import http from "../http-common";

class RoomService {
  createRoom(data) {
      return http.post(`/api/room_per_examiner`, data);
    }
  getRooms() {
    return http.get(`/api/room_per_examiner`);
  }
  getRoom(id) {
    return http.get(`/api/room_per_examiner/`+id);
  }
  getRoomByFilter(data) {
    return http.get(`/api/room_per_examiner/getRoomByFilter?room_name=`+data.room_name);
  }
  updateroom(id, data) {
    return http.put(`/api/room_per_examiner/${id}`, data);
  }
}

export default new RoomService();